const BASE = import.meta.env.VITE_API_URL ?? '';
let token = '';
export const setDetailToken = (t: string) => { token = t; };

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    ...init,
    // No body, no content type: the server reads the header as a promise
    // of JSON and refuses the request when none arrives.
    headers: { ...(init.body == null ? {} : { 'content-type': 'application/json' }),
      authorization: `Bearer ${token}`, ...(init.headers ?? {}) },
  });
  if (!res.ok) {
    const b = await res.json().catch(() => ({}));
    throw new Error(b.error ?? `http_${res.status}`);
  }
  return res.status === 204 ? (undefined as T) : res.json();
}
